import { clearGridData } from '../actions/agGrid';
import { locationPath } from './app-routes';
import { userActions } from './user-actions';

export const navigation = (translations) => {
  const translation = translations || {};

  return {
    items: [
      {
        id: 'portal',
        title: translation.PORTAL,
        type: 'group',
        children: [
          {
            id: 'dashboard',
            title: translation.DASHBOARD,
            type: 'item',
            url: locationPath.DASHBOARD,
            icon: 'fas fa-house',
          },
          {
            id: 'privacyPolicy',
            title: translation.PRIVACY_POLICY,
            type: 'item',
            url: locationPath.PRIVACY_POLICY,
            icon: 'fas fa-shield-halved',
          },
        ],
      },
      {
        id: 'admin_panel',
        title: translation.ADMINISTRATION_TITLE,
        type: 'group',
        children: [
          {
            id: 'auditLoginEvents',
            title: translation.AUDIT_LOGIN_EVENTS,
            type: 'item',
            url: locationPath.AUDIT_LOGIN_EVENTS,
            icon: 'fas fa-key',
            action: userActions.MENU_AUDIT_LOGIN_EVENTS,
          },
          {
            id: 'httpTraces',
            title: translation.AUDIT_HTTP_TRACE,
            type: 'item',
            url: locationPath.AUDIT_HTTP_TRACE,
            icon: 'fas fa-directions',
            action: userActions.MENU_AUDIT_HTTP_TRACE,
          },
          {
            id: 'users',
            title: translation.USER_LIST,
            type: 'item',
            url: locationPath.USER_LIST,
            icon: 'fas fa-users',
            action: userActions.MENU_USER,
          },
          {
            id: 'roles',
            title: translation.ROLE_LIST,
            type: 'item',
            url: locationPath.ROLE_LIST,
            icon: 'fas fa-user-tag',
            action: userActions.MENU_ROLE,
          },
          {
            id: 'administration',
            title: translation.ADMINISTRATION_MENU_ITEM,
            type: 'item',
            url: locationPath.ADMINISTRATION,
            icon: 'fas fa-table',
            action: userActions.MENU_ADMINISTRATION,
          },
          {
            id: 'channels',
            title: translation.CHANNEL_LIST,
            type: 'item',
            url: locationPath.CHANNEL_LIST,
            icon: 'fa fa-music',
            action: userActions.MENU_CHANNEL,
          },
          {
            id: 'codeCodebookTypes',
            title: translation.CODE_CODEBOOK_TYPES,
            type: 'item',
            url: locationPath.CODE_CODEBOOK_TYPES,
            icon: 'fas fa-boxes',
            action: userActions.MENU_CODE_CODEBOOK_TYPES,
            action_onClick: () =>
              clearGridData(locationPath.CODE_CODEBOOK_TYPES),
          },
        ],
      },
      {
        id: 'authors',
        title: translation.AUTHORS,
        type: 'group',
        children: [
          {
            id: 'authors_work',
            title: translation.AUTHORS_WORK,
            type: 'item',
            url: locationPath.AUTHORS_WORK,
            icon: 'fas fa-record-vinyl',
            action: userActions.MENU_AUTHORS_WORK,
            action_onClick: () => clearGridData(locationPath.AUTHORS_WORK),
          },
          {
            id: 'monitorng',
            title: translation.MONITORING,
            type: 'item',
            url: locationPath.MONITORING,
            icon: 'fas fa-tv',
            action: userActions.MENU_MONITORING,
            action_onClick: () => clearGridData(locationPath.MONITORING),
          },
        ],
      },
      {
        id: 'compilations',
        title: translation.COMPILATIONS,
        type: 'group',
        children: [
          {
            id: 'compilationsView',
            title: translation.COMPILATIONS_VIEW,
            type: 'item',
            url: locationPath.COMPILATIONS_VIEW,
            icon: 'fas fa-record-vinyl',
            action: userActions.MENU_COMPILATIONS,
            action_onClick: () => clearGridData(locationPath.COMPILATIONS_VIEW),
          },
        ],
      },
      process.env.REACT_APP_SHOW_MENU_DEV === 'true' && {
        id: 'standards',
        title: translation.COMPONENT_DEMO_PAGE,
        type: 'group',
        children: [
          {
            id: 'standard',
            title: translation.COMPONENT_DEMO_PAGE,
            type: 'item',
            url: locationPath.COMPONENT_DEMO_PAGE,
            icon: 'fas fa-share',
            action: userActions.MENU_USER,
          },
        ],
      },
    ],
  };
};
